import { map, Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { ApiResponse, TripRoute } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  private apiService = inject(ApiService);

  getRoute(routeId: string): Observable<TripRoute> {
    return this.apiService.get<ApiResponse<TripRoute>>(`route/${routeId}`).pipe(map((res) => res.data));
  }
}
